import * as api from '@/employees/api'
import { storeAllEntities } from '@/helpers/store'

const getDefaultStudyPlanState = () => {
  return {
    mySubscriptions: {},
    studentCharacteristics: {},
    users: {},
  }
}

export default {
  state: getDefaultStudyPlanState,
  mutations: {
    RESET_STUDYPLAN_STATE (state) {
      Object.assign(state, getDefaultStudyPlanState())
    },
  },
  actions: {
    getStudyPlanSubscribableGroupings ({ commit, state }, { studentId, queryParams }) {
      return api.getStudyPlanSubscribableGroupings(studentId, queryParams)
        .then(storeAllEntities(commit))
    },
    getStudyPlanStudentCharacteristics ({ commit, state }, { studentId, queryParams }) {
      return api.getStudyPlanStudentCharacteristics(studentId, queryParams)
        .then(storeAllEntities(commit))
    },
    postStudyPlanApproved ({ commit, state }, { studentId, data }) {
      return api.postStudyPlanApproved(studentId, data)
    },
    postStudyPlanUnApproved ({ commit, state }, { studentId, data }) {
      return api.postStudyPlanUnApproved(studentId, data)
    },
    resetStudyPlanState ({ commit, state }) {
      commit('RESET_STUDYPLAN_STATE')
    },
    postUnsubscriptionCourse ({ commit, state }, { studentId, data }) {
      return api.postUnsubscriptionCourse(studentId, data)
    },
  },
  getters: {},
}
